/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Vekn_Link_Same_PersonInputs */



/**
* | output |
* | --- |
* | "This VEKN ID's holder shares an email address with this account, so they are the same person. Ask an IC to merge the two accounts instead." |
*
* @param {Err_Vekn_Link_Same_PersonInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_vekn_link_same_person = /** @type {((inputs?: Err_Vekn_Link_Same_PersonInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Vekn_Link_Same_PersonInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le titulaire de cet ID VEKN partage une adresse email avec ce compte : c'est la même personne. Demandez plutôt à un IC de fusionner les deux comptes.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El titular de este ID VEKN comparte una dirección de correo con esta cuenta, así que son la misma persona. Pide a un IC que fusione las dos cuentas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O titular deste ID VEKN partilha um endereço de e-mail com esta conta, portanto é a mesma pessoa. Peça a um IC que una as duas contas.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il titolare di questo ID VEKN condivide un indirizzo email con questo account, quindi è la stessa persona. Chiedi a un IC di unire i due account.")
	return /** @type {LocalizedString} */ ("This VEKN ID's holder shares an email address with this account, so they are the same person. Ask an IC to merge the two accounts instead.")
});